// Dashboard Users profile & geography page translations (en-US), loaded into dashboard.users.profile by ../en-US.users.js
module.exports = {
  menu: "Profile & geography",
  title: "Profile & Geography",
  description: "Gender, age range and origin of the users active in the period.",
  kpis: {
    avgAge: "Average age",
    genderInformed: "Gender informed",
    birthInformed: "Birth date informed",
    topAge: "Range with most users",
    countries: "Countries",
    regions: "States and regions",
    cities: "Cities",
    topCountry: "Country with most users",
  },
  info: {
    avgAge: "Average age of the users active in the period who informed their birth date.\nSource: Firebase (profiles of the users active in the period).",
    genderInformed: "Users active in the period who informed their gender.\nSource: Firebase (profiles of the users active in the period).",
    birthInformed: "Users active in the period who informed their birth date.\nSource: Firebase (profiles of the users active in the period).",
    topAge: "Age range with the most users active in the period.\nSource: Firebase (profiles of the users active in the period).",
    countries: "Countries in the address of the users active in the period.\nSource: Firebase (profiles of the users active in the period).",
    regions: "States and regions in the address of the users active in the period.\nSource: Firebase (profiles of the users active in the period).",
    cities: "Cities in the address of the users active in the period.\nSource: Firebase (profiles of the users active in the period).",
    topCountry: "Country with the most users active in the period.\nSource: Firebase (profiles of the users active in the period).",
  },
  hints: {
    ofBase: "{value} of the base",
    withUsers: "with active users",
  },
  years: "{value} years",
  age: {
    1317: "13–17",
    1824: "18–24",
    2534: "25–34",
    3544: "35–44",
    4554: "45–54",
    5564: "55–64",
    6500: "65+",
  },
  continents: {
    europe: "Europe",
    southAmerica: "South America",
    northAmerica: "North America",
    africa: "Africa",
    asia: "Asia",
    oceania: "Oceania",
  },
  panels: {
    gender: "Gender",
    users: "users",
    age: "Age range",
    ageNote: "Users under 18 only appear in aggregated data, as the GDPR requires.",
    map: "Map — users by city",
    continents: "Continents",
    countriesSub: "countries",
    topCountries: "Top 10 countries",
    topCities: "Top 10 cities",
  },
  panelInfo: {
    gender: "Users active in the period by gender.\nSource: Firebase (profiles of the users active in the period).",
    age: "Users active in the period by age range.\nSource: Firebase (profiles of the users active in the period).",
    map: "Users active in the period by city of the address.\nSource: Firebase (profiles of the users active in the period).",
    continents: "Users active in the period by continent of the address.\nSource: Firebase (profiles of the users active in the period).",
    topCountries: "Countries with the most users active in the period.\nSource: Firebase (profiles of the users active in the period).",
    topCities: "Cities with the most users active in the period.\nSource: Firebase (profiles of the users active in the period).",
  },
};
